import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { capitalizeFirstLetter } from './string';

function room(type, label, count) {
    return {type, label, count};
}

function singleRoom(count, label) {
    return room('single', label, count);
}

function doubleRoom(count, label) {
    return room('double', label, count);
}

function tripleRoom(count, label) {
    return room('triple', label, count);
}

export function getRoomTypes(guests, translation, useTripleRooms) {
    const remainder = guests % 2;
    const rooms = (guests - remainder) / 2;

    if (guests <= 1) {
        return [singleRoom(1, translation.single)];
    }

    if (rooms === 1) {
        return useTripleRooms
            ? [tripleRoom(1, translation.triple)]
            : [
                doubleRoom(1, translation.double),
                remainder === 1 ? singleRoom(1, translation.single) : null,
            ]
                .filter(Boolean);
    }

    return useTripleRooms
        ? [
            doubleRoom(rooms - 1, translation.double),
            tripleRoom(1, translation.triple),
        ]
        : [
            doubleRoom(rooms, translation.double),
            remainder === 1 ? singleRoom(1, translation.single) : null,
        ]
            .filter(Boolean);
}

export function getHotelRoomTypesList(guests, translation, useTripleRooms) {
    return getRoomTypes(guests, translation, useTripleRooms)
        .map((room, index) => {
            return '%count x %label'
                .replace('%count', room.count)
                .replace(
                    '%label',
                    room.label.toLowerCase(),
                );
        });
}

export function formatHotelDate(date) {
    return format(
        date,
        'EEEE d MMM yyyy',
        {locale: enUS},
    );
}

export function formatHotelNights(range) {
    let label = 'nätter';
    if (range.length === 1) {
        label = 'natt';
    }

    return `${range.length} ${label}`;
}

export function formatHotelRange(range) {
    const from = range.from
        ? new Date(range.from)
        : null;
    const to = range.to
        ? new Date(range.to)
        : null;

    return capitalizeFirstLetter(
        [
            from && formatHotelDate(from),
            to && formatHotelDate(to),
        ].filter(Boolean).join(' - '),
    );
}
